import React from 'react'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button
} from 'reactstrap'
import { FaMapPin, FaBriefcase, FaEdit, FaShare } from 'react-icons/fa'

const UserProfile = ({ user }) => {

  const firstInitial = user?.first_name?.[0] || '';
  const lastInitial = user?.last_name?.[0] || '';
  const initials = (firstInitial + lastInitial).toUpperCase();

  return (
    <Card className="border-0 shadow-sm mt-3 p-1">
      <CardBody className="p-5">
        <div className="d-flex align-items-center">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: '130px',
              height: '140px',
              background: 'linear-gradient(135deg, #7F77DD, #534AB7)',
              color: 'white',
              fontSize: '32px',
              fontWeight: 'bold'
            }}
          >
            {initials}
          </div>

          <div style={{ marginLeft: '20px' }}>
            <h4 className="mb-1 fw-bold">
              {user?.first_name} {user?.last_name}
            </h4>

            <p className="text-muted mb-2">
              {user?.email_id}
            </p>

            <p className="text-muted mb-0">
              {user?.role_name}
            </p>
          </div>

        </div>
      </CardBody>
    </Card>
  );
};

export default UserProfile